<template>
  <div>
    <check-selector-collapse
      :icon="icon"
      :label="label"
      :options="options"
      @checked="handleChecked"
    />
  </div>
</template>

<script>
import CheckSelectorCollapse from '../../../../commons/forms/CheckSelectorCollapse.vue';
import farmacias from '@/api/farmacias.api';
import { mapActions } from 'vuex';
import { mapState } from 'vuex';

export default {
  name: 'FarmaciaSelector',
  components: { CheckSelectorCollapse },
  extends: farmacias,
  props: {
    label: {
      type: String,
      default: 'Farmacia',
    },
    icon: {
      type: String,
      default: 'icon-pharmacy',
    },
  },
  data() {
    return {
      options: [],
      selectedItems: [],
      selectedItemsSet: new Set(),
    };
  },
  computed: {
    ...mapState('filters', ['filtros']),
  },
  watch: {
    'filtros.farmacias': function () {
      this.syncSelectedItemsWithStore();
    },
  },
  mounted() {
    this.loadItems();
  },
  methods: {
    loadItems() {
      let loadPromise = new Promise((resolve) => {
        this.getFarmacias(resolve, this.request);
      });

      loadPromise.then((data) => {
        this.options = data.map((item) => ({
          text: item.nombre,
          value: item.id_farmacia,
          selected: false,
        }));
      });
    },
    syncSelectedItemsWithStore() {
      const farmaciassSeleccionados = this.filtros.farmacias || [];

      const selectedItemsSet = new Set();

      farmaciassSeleccionados.forEach((farmacia) => {
        selectedItemsSet.add(String(farmacia.codigo));
        selectedItemsSet.add(String(farmacia.value));
      });

      this.options = this.options.map((item) => {
        item.selected = selectedItemsSet.has(String(item.value));
        return item;
      });
      console.log(this.options);
      console.log(farmaciassSeleccionados);
    },
    handleChecked(newSelectedItems) {
      const farmaciassSeleccionados = this.filtros.farmacias || [];

      if (!Array.isArray(newSelectedItems)) {
        newSelectedItems = [newSelectedItems];
      }

      newSelectedItems.forEach((selected) => {
        const valueToCheck = String(selected.value);

        if (selected.selected) {
          this.selectedItemsSet.add(valueToCheck);
        } else {
          this.selectedItemsSet.delete(valueToCheck);
        }
      });

      let selectedItemsArray = Array.from(this.selectedItemsSet);

      farmaciassSeleccionados.forEach((item) => {
        const valueToCheck = item.value
          ? String(item.value)
          : String(item.codigo);

        if (!selectedItemsArray.includes(valueToCheck)) {
          selectedItemsArray.push(valueToCheck);
        }
      });

      newSelectedItems.forEach((selected) => {
        if (!selected.selected) {
          const valueToCheck = String(selected.value);
          selectedItemsArray = selectedItemsArray.filter(
            (item) => item !== valueToCheck
          );
        }
      });

      const selectedItems = newSelectedItems.map((item) => item.value);
      this.updateFiltros({
        filtro: 'farmacias',
        items: selectedItems,
      });
      this.emitSelectedItems();
    },

    emitSelectedItems() {
      const selectedItemsArray = Array.from(this.selectedItemsSet);
      this.$emit('update_filters', selectedItemsArray);
    },
    ...mapActions('filters', ['updateFiltros']),
  },
};
</script>
